import httpClient from 'agentHTTPClient';
import httpV3Client from 'agentHTTPV3Client';
import routes from 'agentRoutes';
import reportToRollbar from 'sharedWebpack/reportToRollbar';

const fetchJourneyElement = async (journeyElementType, journeyElementId) => {
  const { data } = await httpClient.get(
    routes.api.fetchJourneyElement({
      type: journeyElementType,
      id: journeyElementId,
    }),
  );

  return data;
};

const fetchTravelers = async id => {
  const { data } = await httpClient.get(
    routes.admin.offlineBookings.travelers.list({
      order_item_id: id,
    }),
  );

  return data.travelers;
};

const fetchSeatMap = async (orderId, orderItemId) => {
  const { data } = await httpV3Client.get(
    routes.api.flights.seat.fetchMap({
      orderId,
      orderItemId,
    }),
  );

  return data;
};

const fetchSubItems = async orderItemId => {
  const { data } = await httpClient.get(
    routes.admin.orderItems.subItems({
      id: orderItemId,
    }),
  );

  return data;
};

const fetchPostBookingActionStatus = async (orderItemId, postBookingActionId, params) => {
  const { data } = await httpV3Client.get(
    routes.api.flights.seat.postBookingAction.fetch({ orderItemId, postBookingActionId }),
    params,
  );

  return data;
};

const addSeat = async (orderId, orderItemId, params) => {
  const { data } = await httpV3Client.post(
    routes.api.flights.seat.add({ orderId, orderItemId }),
    params,
  );

  return data;
};

const fetchOrderedJourneyElementsByType = async (itemId, type) => {
  const { data } = await httpV3Client.get(
    routes.api.fetchOrderedJourneyElementsByType({
      id: itemId,
      type,
    }),
  );

  return data;
};

const fetchFormOfPayment = async formOfPaymentId => {
  const { data } = await httpClient.get(
    routes.admin.formOfPayments.show({
      id: formOfPaymentId,
    }),
  );

  const { type, cardDetails } = data.formOfPayment;

  return { type, card: cardDetails };
};

const fetchAffiliateVerificationStatus = async () => {
  try {
    const { data } = await httpV3Client.get(routes.api.affiliateVerifiedStatus());
    const fetchedStatus = data.tenantSetting.affiliateVerified;
    return fetchedStatus;
  } catch (error) {
    reportToRollbar('Failed to Fetch Affiliate Verification Status', error);
    return false;
  }
};

export {
  fetchJourneyElement,
  fetchTravelers,
  fetchSeatMap,
  fetchSubItems,
  fetchPostBookingActionStatus,
  addSeat,
  fetchFormOfPayment,
  fetchAffiliateVerificationStatus,
  fetchOrderedJourneyElementsByType,
};
